import React from "react";
import {
  isOrientationCandidate,
  orientationLabel,
  stabilityLabel,
} from "./needsApplicationModel";

export default function CapabilityCore({ capabilityLabel, state }) {
  const candidate = isOrientationCandidate(state);

  return (
    <article className={`v25a-capability-core ${candidate ? "candidate" : "resultant"}`}>
      <span className="v25a-eyebrow">STABILT SENTRUM · CAPABILITY</span>
      <h2>{capabilityLabel}</h2>
      <p>
        Selve kapabiliteten endres ikke når du bytter konfigurasjon.
        Det er den relasjonelle topologien rundt den som blir annerledes.
      </p>

      <div className="v25a-core-receipt">
        <span>
          <b>{state?.independent_root_count ?? 0}</b>
          uavhengige røtter
        </span>
        <span>
          <b>{state?.pathway_count ?? 0}</b>
          pathways
        </span>
      </div>

      <div className={`v25a-orientation-pill ${candidate ? "candidate" : ""}`}>
        {candidate ? "Orientation candidate" : orientationLabel(state?.orientation)}
      </div>

      <small className="v25a-core-status">
        {candidate
          ? "Ikke promotert til multi-root resultant"
          : stabilityLabel(state?.stability_class)}
      </small>
    </article>
  );
}
